document.addEventListener('DOMContentLoaded', () => {
  const variantSelector = document.querySelector('.product-variant-selector');
  const variantSelectorSelectedOption = variantSelector?.querySelector('option[selected="selected"]')?.value;
  const variantInventoryListScript = document.querySelector('#variant-inv-metafields-json');
  if (!variantSelector || !variantInventoryListScript) return;

  const variantInventoryList = JSON.parse(variantInventoryListScript.textContent);
  dynamicButton(variantInventoryList[variantSelectorSelectedOption]);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'selected' &&
        mutation.target.tagName === 'OPTION' &&
        mutation.target.selected
      ) {
        const selectedValue = mutation.target.value;
        const variantData = variantInventoryList[selectedValue];
        if (variantData) dynamicButton(variantData);
      }
    }
  });

  observer.observe(variantSelector, {
    attributes: true,
    subtree: true,
    attributeFilter: ['selected'],
  });

  function dynamicButton(variantData) {
    const atcButton = document.querySelector('.ProductForm__AddToCart span');
    const preOrderEndContainer = document.querySelector('#pre-order-end-container');
    const preOrderEnd = document.querySelector('#pre-order-end-container .pre-order-end-msg');
    const imgBadge = document.querySelector('.availability-badge');
    const preOrderLineItem = document.querySelector('[data-preorder-status]');
    
    // Define Stocks
    const usStock = variantData.radial_indy_1_pre_orders;
    const ukStock = variantData.jaki_unit_2_pre_orders;
    
    // CHECK: Is the customer in the US?
    if (Shopify.country === 'US') {
      // --- US LOGIC (Radial Indy 1) ---
      const mainStock = variantData.inventory_quantity - variantData.radial_indy_1_pre_orders;
      if (mainStock > 0) {
        if (atcButton) atcButton.textContent = 'Add to Cart';
        if (preOrderEndContainer) preOrderEndContainer.classList.add('hide-this');
        if (preOrderEnd) preOrderEnd.textContent = '';
        if (imgBadge) imgBadge.classList.add('hide-this');
        if(preOrderLineItem) preOrderLineItem.value = "";
      } else if (variantData.radial_indy_1_pre_orders > 0) {
        if (atcButton) atcButton.textContent = 'Pre-order';
        if (imgBadge) {
          imgBadge.textContent = 'PRE ORDER';
          imgBadge.classList.remove('hide-this'); // Fix visibility
        }
        if(preOrderLineItem) preOrderLineItem.value = "Pre order";
        if (preOrderEndContainer) {
          preOrderEndContainer.classList.remove('hide-this');
          preOrderEnd.textContent = variantData.pre_order_end_date_us ? `${variantData.pre_order_end_date_us}` : '';
        }
      } else {
        if (preOrderEndContainer) preOrderEndContainer.classList.add('hide-this');
        if (preOrderEnd) preOrderEnd.textContent = '';
        if (atcButton) atcButton.textContent = 'Sold Out';
        if (imgBadge) imgBadge.textContent = 'SOLD OUT';
        if(preOrderLineItem) preOrderLineItem.value = "";
      }
    } else {
      // --- REST OF WORLD LOGIC (JAKI Unit 2) ---
      // This covers UK, Europe, Australia, etc.
      const mainStock = variantData.inventory_quantity - variantData.jaki_unit_2_pre_orders;
      if (mainStock > 0) {
        if (atcButton) atcButton.textContent = 'Add to Cart';
        if (preOrderEndContainer) preOrderEndContainer.classList.add('hide-this');
        if (preOrderEnd) preOrderEnd.textContent = '';
        if (imgBadge) imgBadge.classList.add('hide-this');
        if(preOrderLineItem) preOrderLineItem.value = "";
      } else if (variantData.jaki_unit_2_pre_orders > 0) {
        if (atcButton) atcButton.textContent = 'Pre-order';
        if (imgBadge) {
          imgBadge.textContent = 'PRE ORDER';
          imgBadge.classList.remove('hide-this'); // Fix visibility
        }
        if(preOrderLineItem) preOrderLineItem.value = "Pre order";
        if (preOrderEndContainer) {
          preOrderEndContainer.classList.remove('hide-this');
          preOrderEnd.textContent = variantData.pre_order_end_date_uk ? `${variantData.pre_order_end_date_uk}` : '';
        }
      } else {
        if (preOrderEndContainer) preOrderEndContainer.classList.add('hide-this');
        if (preOrderEnd) preOrderEnd.textContent = '';
        if (atcButton) atcButton.textContent = 'Sold Out';
        if (imgBadge) imgBadge.textContent = 'SOLD OUT';
        if(preOrderLineItem) preOrderLineItem.value = "";
      }
    }
      
  }
});
